function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
/* eslint class-methods-use-this: "off" */
import GridUtils from "../GridUtils.js";
import GridSeparatorMouseHandler from "./GridSeparatorMouseHandler.js";
class GridRowSeparatorMouseHandler extends GridSeparatorMouseHandler {
  constructor() {
    super(...arguments);
    _defineProperty(this, "hiddenCursor", 's-resize');
    _defineProperty(this, "defaultCursor", 'row-resize');
    _defineProperty(this, "pointProperty", 'y');
    _defineProperty(this, "userSizesProperty", 'userRowHeights');
    _defineProperty(this, "visibleOffsetProperty", 'visibleRowYs');
    _defineProperty(this, "visibleSizesProperty", 'visibleRowHeights');
    _defineProperty(this, "marginProperty", 'columnHeaderHeight');
    _defineProperty(this, "calculatedSizesProperty", 'calculatedRowHeights');
    _defineProperty(this, "initialSizesProperty", 'initialRowHeights');
    _defineProperty(this, "modelIndexesProperty", 'modelRows');
    _defineProperty(this, "firstIndexProperty", 'firstRow');
    _defineProperty(this, "treePaddingProperty", 'treePaddingY');
    _defineProperty(this, "getHiddenItems", GridUtils.getHiddenRows);
    _defineProperty(this, "getNextShownItem", GridUtils.getNextShownRow);
    _defineProperty(this, "getSeparator", GridRowSeparatorMouseHandler.getRowSeparator);
  }
  static getRowSeparator(gridPoint, metrics, model, theme) {
    if (!theme.allowRowResize) {
      return null;
    }
    var x = gridPoint.x,
      y = gridPoint.y;
    var index = GridUtils.getRowSeparatorIndex(x, y, metrics, theme);
    return index != null ? {
      index,
      depth: 0
    } : null;
  }
  setSize(metricCalculator, modelIndex, size) {
    metricCalculator.setRowHeight(modelIndex, size);
  }
  resetSize(metricCalculator, modelIndex) {
    metricCalculator.resetRowHeight(modelIndex);
  }
  updateSeparator(grid, separator) {
    grid.setState({
      draggingRowSeparator: separator,
      isDragging: separator !== null
    });
  }
}
export default GridRowSeparatorMouseHandler;
//# sourceMappingURL=GridRowSeparatorMouseHandler.js.map